export const volumesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Range',
  },
  {
    name: 'riskScore',
    label: 'Score',
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
];

export const volumesDefaultSorter = {};

export const volumesSchema = {};

export const volumesFiltersSchema = [];
